import React, { useImperativeHandle, useRef, useState } from "react";
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import { OrdiniApi } from "../../data";
import PdfViewer from "../pdfViewer/PdfViewer";
import { apiConfiguration } from "../../apiConfig";
import { LoadIndicator } from "devextreme-react";
import PopupSignaturePanel, { SignaturePanelPopupHandle } from "../popupSignaturePanel/popupSignaturePanel";
import { useTranslation } from 'react-i18next';

type Props = {
}

export type OrderReportPopupHandle = {
  show: (idOrdine: number) => void
}

type State = {
  idOrdine: number,
  allowSign: boolean,
  visible: boolean
}

const PopupOrderReport: React.ForwardRefRenderFunction<OrderReportPopupHandle, Props> = (props, ref) => {
  const [pdfBlob, setPdfBlob] = useState<Blob>();
  const [state, setState] = useState<State>({ idOrdine: 0, allowSign: false, visible: false });
  const [loading, setLoading] = useState(false);
  const signatureRef = useRef<SignaturePanelPopupHandle>(null);
  const { t } = useTranslation();

  useImperativeHandle(ref, () => ({
    show(idOrdine) {
      if (idOrdine != 0)
        (async function () {
          var ordiniApi = new OrdiniApi(apiConfiguration);

          setLoading(true);

          var ordine = await ordiniApi.getOrdineById({ idOrdine: idOrdine });

          setState({
            idOrdine: ordine.idOrdine ?? 0,
            allowSign: ordine.allowSign ?? false,
            visible: true
          });

          if (ordine.isSigned)
            setPdfBlob(await ordiniApi.getOrdineReportSigned({ idOrdine: idOrdine }));
          else
            setPdfBlob(await ordiniApi.getOrdineReport({ idOrdine: idOrdine }));

          setLoading(false);
        })();
    }
  }));

  async function signatureSubmitBlob(blob: Blob) {
    signatureRef.current?.hide();

    setLoading(true);

    var api = new OrdiniApi(apiConfiguration);

    var responseBlob = await api.setOrdineReportSign({ idOrdine: state.idOrdine, sign: blob });

    setPdfBlob(responseBlob);

    setLoading(false);
  }

  return (
    <React.Fragment>
      <Popup
        visible={state.visible}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={false}
        showTitle={false}
        fullScreen={true}
        title="Ordine"
        container=".dx-viewport"
      >
        <Position
          at="center"
          my="center"
          of=""
          collision="fit"
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="center"
          options={{
            text: t('chiudi'),
            onClick: () => setState({ ...state, visible: false })
          }}
        />
        {state.allowSign &&
          <ToolbarItem
            widget="dxButton"
            toolbar="top"
            location="center"
            options={{
              text: t('firma'),
              onClick: signatureRef.current?.show,
            }}
          />
        }

        {loading &&
          <div style={{ position: "relative", bottom: 0, top: 0, left: 0, right: 0, height: 'auto', width: 'auto', verticalAlign: 'middle', textAlign: 'center' }}>
            <LoadIndicator id="medium-indicator" />
          </div>
        }

        {!loading && <PdfViewer pdfBlob={pdfBlob} />}

        <PopupSignaturePanel ref={signatureRef} onSubmitBlob={signatureSubmitBlob} />
      </Popup>
    </React.Fragment>
  );
}

export default React.forwardRef(PopupOrderReport);

